<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-25 17:22:57
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-25 17:26:37
-->
<template>
    <router-view />
</template>

<script>
export default {
	name: 'SupplyManage',
};
</script>